import React, { useContext } from 'react';
import AppContext from './context/AppContext';
import { FaCheck } from 'react-icons/fa';
import '../styles/HomeFeaturesList.css';

const HomeFeaturesList = () => {
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;
    return (
        <div
            className={'home-features-list d-flex justify-content-between mb-2'}>
            {appConfig.features.map((feature) => (
                <div
                    className={'d-flex gap-2'}
                    key={feature.title}>
                    <FaCheck
                        size={24} />
                    <span
                        className={'home-features-list--text'}
                        style={{
                            color: 'var(--primary-color)',
                        }}>{feature.title}</span>
                    <span
                        className={'text-muted home-features-list--text'}>
                        {feature.description}
                    </span>
                </div>
            ))}
        </div>
    );
};

export default HomeFeaturesList;